import { useRef } from 'react';
import PropTypes from 'prop-types';
import { useOnClickOutside } from 'utils/functions/hooks';
import Loader from 'modules/shared/common/components/Loader';
import {
  ModalContainer,
  ModalDialog,
  ModalHeader,
  Title,
  ModalBody,
  ModalActions,
  ModalButton,
  ModalConfirmButton,
  PreventBodyScrolling,
  ModalCloseIcon,
} from './Modal.style';

const Modal = props => {
  const {
    toggle,
    size,
    title,
    children,
    onClose,
    onCancelHandler,
    cancelActionLabel,
    onConfirmHandler,
    disableConfirmButton,
    confirmActionLabel,
    confirmActionLoading,
  } = props;
  const containerRef = useRef();

  const handleClose = () => {
    onClose();
  };

  useOnClickOutside(containerRef, handleClose);

  return (
    <ModalContainer data-testid="modal-container" toggle={toggle}>
      {toggle && <PreventBodyScrolling isOpen={toggle} />}
      <ModalDialog data-testid="modal-card" ref={containerRef} size={size}>
        <ModalHeader data-testid="modal-header">
          <Title data-testid="modal-title">{title}</Title>
          <ModalCloseIcon data-testid="modal-close-icon" onClick={handleClose} />
        </ModalHeader>
        <ModalBody data-testid="modal-body">{children !== '' && children}</ModalBody>
        {onConfirmHandler && (
          <ModalActions data-testid="modal-actions">
            <ModalButton
              data-testid="modal-cancel-button"
              onClick={() => {
                if (onCancelHandler !== undefined) onCancelHandler();
              }}
            >
              {cancelActionLabel || 'Cancel'}
            </ModalButton>
            <ModalConfirmButton
              data-testid="modal-confirm-button"
              onClick={() => {
                onConfirmHandler();
              }}
              disabled={disableConfirmButton}
            >
              {(confirmActionLoading && <Loader width={14} height={14} thickness={4} />) ||
                confirmActionLabel ||
                'Save'}
            </ModalConfirmButton>
          </ModalActions>
        )}
      </ModalDialog>
    </ModalContainer>
  );
};

export default Modal;

Modal.propTypes = {
  size: PropTypes.string,
  title: PropTypes.string,
  toggle: PropTypes.bool.isRequired,
  onClose: PropTypes.func,
  onCancelHandler: PropTypes.func,
  cancelActionLabel: PropTypes.string,
  onConfirmHandler: PropTypes.func,
  confirmActionLabel: PropTypes.string,
  disableConfirmButton: PropTypes.bool,
  confirmActionLoading: PropTypes.bool,
  children: PropTypes.node,
};
Modal.defaultProps = {
  title: 'modal title',
  size: 'md',
  onClose: () => {},
  onCancelHandler: () => {},
  cancelActionLabel: 'Cancel',
  onConfirmHandler: () => {},
  confirmActionLabel: 'Save',
  disableConfirmButton: false,
  confirmActionLoading: false,
  children: '',
};
